import React, { useEffect, useState } from "react";
import FeedDesktopRightPanel from "./FeedDesktopRightPanel";

function isDesktopViewport() {
  return typeof window !== "undefined" ? window.innerWidth >= 769 : false;
}

export default function DesktopRightRail({
  className = "",
  currentUser,
  posts = [],
  users = [],
  onOpenUser,
}) {
  const [isDesktop, setIsDesktop] = useState(isDesktopViewport);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const handleResize = () => setIsDesktop(isDesktopViewport());
    handleResize();
    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
    };
  }, []);

  if (!isDesktop) return null;

  return (
    <div
      className={`utility-page-right-rail rp-shell rp-home-shell${
        className ? ` ${className}` : ""
      }`}
    >
      <FeedDesktopRightPanel
        currentUser={currentUser}
        posts={posts}
        users={users}
        onOpenUser={onOpenUser}
      />
    </div>
  );
}
